// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

export const breadcrumbs = [
  { label: 'Program Management', to: programManagementRouteCreator.base() },
  { label: 'Referral Program' },
];
